<template>
  <section
    v-if="mergeRequest"
    class="d-flex flex-wrap mt-3"
  >
    <div class="col-sm-9 pl-0 pr-0 pr-sm-2 order-2 order-sm-1">
      <div class="w-100">
        <merge-request-approve-rules
          v-if="mrApproversEnabled"
          @approveAction="onApproveAction"
        />
      </div>

      <div
        class="d-flex align-items-center mb-3"
        v-if="
          mergeRequest.mergeStatus.id === 'SOURCE_BRANCH_NEED_TO_REBASE' &&
          mergeRequest.conflicts.length === 0 &&
          !mergeRequest.canConflictsBeResolvedInUI
        "
      >
        <button
          class="btn btn-sm btn-danger mr-2"
          @click="rebaseSourceBranch"
        >
          {{ $t('sourceBranchNeedToRebase') }}
        </button>
        <small class="text-truncate">
          {{ $t('sourceBranchNeedToRebaseDescription') }}
        </small>
      </div>
      <div
        class="mb-3"
        v-else-if="
          mergeRequest.mergeStatus.id === 'SOURCE_BRANCH_NEED_LOCAL_REBASE' &&
          mergeRequest.conflicts.length > 0
        "
      >
        <span class="text-truncate text-danger mb-3">
          {{ $t('sourceBranchNeedToRebaseLocalDescription') }}
        </span>
      </div>

      <merge-request-auto-merge-info
        v-if="
          (mergeRequest && mergeRequest?.autoMergeAllowed) ||
          (mergeRequest && mergeRequest?.autoMergeEnabled) ||
          (mergeRequest && mergeRequest?.autoMergeDisable)
        "
        :user="mergeRequest.userSetToAutoMerge"
        :merge-request="mergeRequest"
        @toggle="mergeRequest.autoMergeEnabled = !mergeRequest.autoMergeEnabled"
      />

      <div class="w-100 border rounded mb-3">
        <div
          class="markdown-body px-4 py-3 break-word"
          :class="{ 'text-muted': !mergeRequest.description }"
        >
          <!-- <vueMarkdown>
            {{ mergeRequest.description || $t('message.description_empty') }}
          </vueMarkdown> -->

          <!-- {{ mergeRequest.description || $t('message.description_empty') }} -->
          <div v-html="mergeRequest.description || $t('message.description_empty')"></div>
        </div>
      </div>
      <div
        v-if="mergeRequest?.mergePipelineActionTypeSet?.includes('SHOW_KRS')"
        class="merge-request__result-automerge my-3"
      >
        <div class="merge-request__result-automerge-no-info">
          <b class="text-muted">{{ $t('noMergeResultPipelineForLastCommit') }}</b>
          <button
            v-if="mergeRequest.conflicts.length == 0"
            class="btn btn-sm btn-primary"
            @click="runMergeResultPipeline"
            :disabled="mergeResultPipelineIsCreating"
          >
            {{ $t('createMergeResultPipeline') }}
          </button>
          <gf-custom-tooltip
            width="max-content"
            v-else
          >
            <template #element>
              <button
                class="btn btn-sm btn-primary"
                @click="runMergeResultPipeline"
                disabled="true"
              >
                {{ $t('createPipeline') }}
              </button>
            </template>
            <template #content>
              {{ $t('runPipelineMergeRequests') }}
            </template>
          </gf-custom-tooltip>
        </div>
      </div>

      <div
        v-if="mergeRequest?.mergePipelineActionTypeSet?.includes('SHOW_KRS_INFO')"
        class="merge-request__result-automerge my-3"
      >
        <div class="merge-request__result-automerge-info">
          <ci-main-status
            v-if="mergeRequest?.mergeResultsPipeline?.status"
            :status="mergeRequest?.mergeResultsPipeline?.status"
          />
          <div>
            <span>
              {{ $t('mergeResultPipeline') }}
              <a
                :href="`/project/${mergeRequest?.targetProject?.ownerAlias}/${mergeRequest?.targetProject?.alias}/ci-cd/pipeline/${mergeRequest?.mergeResultsPipeline?.localId}`"
                class="font-weight-bold"
              >
                #{{ mergeRequest?.mergeResultsPipeline?.localId }}
              </a>
            </span>
            <br />
            <small class="text-muted">
              {{ $t('mergeResultPipelineIsRunningForCommit') }}
              <a
                :href="`/project/${mergeRequest?.targetProject?.ownerAlias}/${mergeRequest?.targetProject?.alias}/commit/${mergeRequest?.mergeResultsPipeline?.commitHash}`"
              >
                <code>{{ mergeRequest?.mergeResultsPipeline?.commitHash?.slice(0, 7) }}</code>
              </a>
              <span v-if="mergeRequest?.mergeResultsPipeline?.finishedAt">
                {{ $moment(mergeRequest?.mergeResultsPipeline?.finishedAt).fromNow() }}
              </span>
            </small>
          </div>
        </div>
      </div>
      <div
        v-if="mergeRequest?.mergePipelineActionTypeSet?.includes('SHOW_KS')"
        class="merge-request__result-automerge my-3"
      >
        <div class="merge-request__result-automerge-no-info">
          <b class="text-muted">{{ $t('noMergeRequestPipelineForLastCommit') }}</b>
          <button
            class="btn btn-sm btn-primary"
            @click="runMergeRequestPipeline"
            :disabled="mergeRequestPipelineIsCreating"
          >
            {{ $t('createMergeRequestPipeline') }}
          </button>
        </div>
      </div>

      <div
        v-if="mergeRequest?.mergePipelineActionTypeSet?.includes('SHOW_KS_INFO')"
        class="merge-request__result-automerge my-3"
      >
        <div class="merge-request__result-automerge-info">
          <ci-main-status
            v-if="mergeRequest?.mergeRequestPipeline?.status"
            :status="mergeRequest?.mergeRequestPipeline?.status"
          />
          <div>
            <span>
              {{ $t('mergeRequestPipeline') }}
              <a
                :href="`/project/${mergeRequest?.targetProject?.ownerAlias}/${mergeRequest?.targetProject?.alias}/ci-cd/pipeline/${mergeRequest?.mergeRequestPipeline?.localId}`"
                class="font-weight-bold"
              >
                #{{ mergeRequest?.mergeRequestPipeline?.localId }}
              </a>
            </span>
            <br />
            <small class="text-muted">
              {{ $t('mergeRequestPipelineIsRunningForCommit') }}
              <a
                :href="`/project/${mergeRequest?.targetProject?.ownerAlias}/${mergeRequest?.targetProject?.alias}/commit/${mergeRequest?.mergeRequestPipeline?.commitHash}`"
              >
                <code>{{ mergeRequest?.mergeRequestPipeline?.commitHash?.slice(0, 7) }}</code>
              </a>
              <span v-if="mergeRequest?.mergeRequestPipeline?.finishedAt">
                {{ $moment(mergeRequest?.mergeRequestPipeline?.finishedAt).fromNow() }}
              </span>
            </small>
          </div>
        </div>
      </div>

      <div
        v-if="
          mergeRequest &&
          mergeRequest.status &&
          (mergeRequest.status.id === 'OPENED' || mergeRequest.status.id === 'TRAINS_CAR_CONFLICT')
        "
      >
        <merge-request-item-merge-area
          v-if="
            getActionAvailabilityFlag(ACTION_ENUM.EDIT_STATUS_OF_MERGE_REQUEST) ||
            getActionAvailabilityFlag(ACTION_ENUM.DO_MERGE_MERGE_REQUEST)
          "
          :merge-request="mergeRequest"
          @merge="onMergeRequest"
          @close="onCloseRequest"
          @cancel="onCancelRequest"
        />
      </div>

      <template v-if="getActionAvailabilityFlag(ACTION_ENUM.READ_DISCUSSION)">
        <merge-request-item-discussions :discussions="mergeRequestDiscussions" />

        <merge-request-discussion-reply-form
          :force-show-editor="true"
          @submitReply="submitStandaloneDiscussion"
        />
      </template>
    </div>

    <div class="col-sm-3 pr-0 order-1 order-sm-2 mb-5">
      <div
        class="d-flex flex-column pb-3 mb-3 border-bottom"
        v-if="mergeRequest.reasonWorkInProgress"
      >
        <div class="d-flex align-items-center font-weight-bolder mb-2 gap-1">
          <i class="gf-icon gf-icon-lock merge-request__lock-icon"></i>
          {{ $t('message.blocked_due_to') }}
        </div>
        <span class="text-muted text-break">{{ mergeRequest.reasonWorkInProgress }}</span>
      </div>

      <merge-request-approvers
        v-if="mrApproversEnabled"
        :has-access="getActionAvailabilityFlag(ACTION_ENUM.APPROVE_MERGE_REQUEST)"
        :merge-request-status="mergeRequest.status"
        @approveAction="onApproveAction"
      />
      <div class="d-flex flex-column mb-3">
        <span class="font-weight-bolder mb-2">
          {{ $tc('message.assigned', 1) }}
        </span>
        <user-label-item
          v-for="user in mergeRequest.assignedUsers"
          :key="user.id"
          :user="user"
          :has-user-link="true"
          :open-in-new-tab="false"
        />
        <empty-listing
          v-if="!!mergeRequest.assignedUsers && !mergeRequest.assignedUsers.length"
          :title="$tc('message.assigned', 2)"
          type="small"
        />
      </div>

      <div class="d-flex flex-column mb-3">
        <span class="font-weight-bolder mb-2">{{ $tc('message.reviewers', 1) }}</span>
        <user-label-item
          v-for="reviewer in mergeRequest.reviewers"
          :key="reviewer.id"
          :user="reviewer"
          :has-user-link="true"
          :open-in-new-tab="false"
        />
        <empty-listing
          v-if="!!mergeRequest.reviewers && !mergeRequest.reviewers.length"
          :title="$tc('message.reviewers', 2)"
          type="small"
        />
      </div>

      <div class="d-flex flex-column border-top pt-3 mb-3">
        <span class="font-weight-bolder mb-2">{{ $tc('message.label', 1) }}</span>
        <repo-label-list :labels="mergeRequest.labels" />

        <empty-listing
          v-if="!!mergeRequest.labels && !mergeRequest.labels.length"
          :title="$tc('message.label', 2)"
          type="small"
        />
      </div>

      <div
        class="d-flex flex-column border-top pt-3 mb-3 gap-1"
        v-if="getActionAvailabilityFlag(ACTION_ENUM.READ_VULNERABILITY)"
      >
        <span class="font-weight-bolder mb-2">Безопасность</span>
        <span>
          <i
            class="gf-icon gf-icon-shield mr-1"
            :class="vulnerabilitesNumbers.SAST ? 'text-danger' : 'text-success'"
          ></i>
          <span>
            {{ vulnerabilitesNumbers.SAST ? 'Есть уязвимости' : 'Нет уязвимостей' }}&nbsp;
          </span>
          <b>SAST</b>
        </span>
        <span>
          <i
            class="gf-icon gf-icon-shield mr-1"
            :class="vulnerabilitesNumbers.DAST ? 'text-danger' : 'text-success'"
          ></i>
          <span>
            {{ vulnerabilitesNumbers.DAST ? 'Есть уязвимости' : 'Нет уязвимостей' }}&nbsp;
          </span>
          <b>DAST</b>
        </span>
      </div>
      <div class="merge-request__about pt-3 mb-3">
        <a
          href="https://docs.gitflic.ru/project/merge_request"
          target="_blank"
        >
          {{ $t('about') }}
        </a>
        <span class="merge-request__about-icon">
          <i class="gf-icon gf-icon-arrow-outward ml-1"></i>
        </span>
      </div>
    </div>
  </section>
  <pacman-loader v-else />
</template>

<script>
import Vue from 'vue';

import MRService from '@shared/services/merge-request.service';
import { messageNotification, smallNotification } from '@shared/services/gf.notification.service';
import helperS from '@shared/services/helper.service';
import RepoLabelList from '@shared/shared-components/shared/repo-label-list';
// eslint-disable-next-line max-len
import MergeRequestItemDiscussions from '@shared/modules/merge-request/components/merge-request-item-discussions';
import UserLabelItem from '@shared/shared-components/shared/user-label-item';
//import vueMarkdown from 'vue-markdown';
import EmptyListing from '@shared/shared-components/empty-listing';
// eslint-disable-next-line max-len
import MergeRequestDiscussionReplyForm from '@shared/modules/merge-request/components/merge-request-discussion-reply-form';
import { EventBus, EventEnums } from '@shared/event-bus';
// eslint-disable-next-line max-len
import MergeRequestItemMergeArea from '@shared/modules/merge-request/components/merge-request-item-merge-area';
import referenceService from '@shared/services/reference.service';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
import MergeRequestAutoMergeInfo from '@shared/modules/merge-request-auto-merge/components/merge-request-auto-merge-info.vue';
import CiMainStatus from '@shared/modules/ci-cd/components/ci-main-status';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import Vulnerabilities from '@/shared-modules/modules/security/security.service';
import mergeRequestMessages from '@/shared-modules/modules/merge-request/mergeRequestMessages';

export default {
  components: {
    PacmanLoader,
    MergeRequestItemMergeArea,
    MergeRequestDiscussionReplyForm,
    UserLabelItem,
    MergeRequestItemDiscussions,
    RepoLabelList,
    // vueMarkdown,
    EmptyListing,
    MergeRequestAutoMergeInfo,
    CiMainStatus
  },
  data() {
    return {
      mergeRequestApproversModule: false,
      mergeRequestPipelineIsCreating: false,
      mergeResultPipelineIsCreating: false,
      vulnerabilitesNumbers: {
        SAST: null,
        DAST: null
      }
    };
  },
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    mergeRequest() {
      return this.$store.getters.getSelectedMergeRequest;
    },
    mergeRequestDiscussions() {
      return this.$store.getters.getMergeRequestsDiscussions;
    },
    mrApproversEnabled() {
      return this.$store.getters.getMrApprovers;
    }
  },
  mounted() {
    referenceService.getSastStatus();

    try {
      // eslint-disable-next-line max-len, global-require
      const mergeRequestApproversComponent = require('@shared/modules/merge-request-approver/components/merge-request-approvers');
      // eslint-disable-next-line vue/match-component-file-name
      Vue.component('MergeRequestApprovers', (resolve) => {
        resolve(mergeRequestApproversComponent);
      });
      // eslint-disable-next-line max-len, global-require
      const mergeRequestApproveRulesComponent = require('@shared/modules/merge-request-approver/components/merge-request-approve-rules');
      // eslint-disable-next-line vue/match-component-file-name
      Vue.component('MergeRequestApproveRules', (resolve) => {
        resolve(mergeRequestApproveRulesComponent);
      });
      this.mergeRequestApproversModule = true;
    } catch (e) {
      console.warn(
        // eslint-disable-next-line max-len
        'Merge request approvers module is NOT included in your package, if you need it - please contact our support'
      );
    }

    if (this.getActionAvailabilityFlag(ACTION_ENUM.READ_DISCUSSION)) {
      MRService.getMergeRequestsDiscussions(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      );
    }

    if (this.getActionAvailabilityFlag(ACTION_ENUM.READ_VULNERABILITY)) {
      this.getVulnerabilitiesInfo('SAST');
      this.getVulnerabilitiesInfo('DAST');
    }
  },
  methods: {
    rebaseSourceBranch() {
      MRService.rebaseSourceBranch(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      ).then(() => {
        window.location.reload();
      });
    },
    getVulnerabilitiesInfo(tool) {
      Vulnerabilities.getVulnerabilitiesByMerge(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id,
        {
          vulnerabilityTool: tool
        }
      ).then((res) => {
        this.vulnerabilitesNumbers[tool] = res.vulnerabilityOccurrencePipelineModel._embedded;
      });
    },
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    submitStandaloneDiscussion(data) {
      MRService.createDiscussion(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        helperS.generateDiscussionObject({ data }, this.mergeRequest)
      ).then(() => {
        EventBus.$emit(EventEnums.MERGE_REQUEST_DISCUSSION_REPLY_CREATED);
        MRService.getMergeRequestsItem(
          this.$route.params.alias,
          this.$route.params.projectAlias,
          this.$route.params.id
        );
      });
    },
    onMergeRequest() {
      if (this.mergeRequestDiscussions.find((x) => !x.note.resolved)) {
        messageNotification('danger', {
          message: 'Есть незакрытые дискуссии!',
          hasTimeline: false
        });
        return;
      }

      MRService.mergeMergeRequest(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      ).then(() => this.updateMR());
    },
    onCancelRequest() {
      MRService.cancelMergeRequest(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      ).then(() => {
        this.updateMR();
        smallNotification('success', { title: 'Запрос на слияние отменен!' });
      });
    },
    onCloseRequest() {
      MRService.closeMergeRequest(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      ).then(() => {
        this.updateMR();
        smallNotification('success', { title: 'Запрос на слияние закрыт!' });
      });
    },
    updateMR() {
      MRService.getMergeRequestsItem(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      );
    },
    onApproveAction() {
      MRService.getMergeRequestsItem(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      );
    },
    runMergeResultPipeline() {
      this.mergeResultPipelineIsCreating = true;
      MRService.runMergeResultPipeline(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      )
        .then(() => {
          this.mergeResultPipelineIsCreating = false;
        })
        .catch(() => {
          this.mergeResultPipelineIsCreating = false;
        });
    },
    runMergeRequestPipeline() {
      this.mergeRequestPipelineIsCreating = true;
      MRService.runMergeRequestPipeline(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      )
        .then(() => {
          this.mergeRequestPipelineIsCreating = false;
        })
        .catch(() => {
          this.mergeRequestPipelineIsCreating = false;
        });
    }
  },
  i18n: {
    messages: mergeRequestMessages
  }
};
</script>

<style lang="scss">
$this: '.merge-request';

#{$this}__result-automerge {
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);

  &-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &-no-info {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
  }
}

#{$this}__about {
  text-wrap-style: balance;

  & > a {
    text-decoration: underline;
  }
  &-icon {
    display: inline-block !important;
    vertical-align: top;
    color: var(--primary);
  }
}

.merge-request__lock-icon {
  margin-top: -3px;
}
</style>
